import React from 'react';
import { FooterWrap, StyledPagination } from 'component/table_component/antTable/pagenation.style';

export default function CustomPagination({
  totalItems,
  currentPage,
  pageSize,
  onPageChange,
  pageSizeOptions,
  startIndex,
  loading,
  endIndex,
}) {
  return (
    <>
      <FooterWrap className='af-pagination-wrap'>
        <div className='af-pagination-content'>
          Show Entries: {startIndex + 1}-{Math.min(endIndex, totalItems)} of {totalItems} items
        </div>

        <div className='af-pagination-sub-wrap'>
          <StyledPagination
            className='af-pagination'
            disabled={loading}
            current={currentPage}
            total={totalItems}
            showSizeChanger
            onChange={onPageChange}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
          />
        </div>
      </FooterWrap>
    </>
  );
}
